export interface RetryMessageDTO {
  body: string;
  header: string;
}

export enum RetryChoice {
  Retry = 'RETRY',
  Finish = 'FINISH',
}
